import * as numeral from 'numeral';

const UNIT = {
    0: 'STRING',
    1: '',
    2: '',
    3: 'GB',
    4: 'MB',
    5: 'KB',
    6: 'BYTE',
    7: '%',
    8: 'TEMPERATURE',
    9: 'ONOFF',
    10: 'TIMES',
    11: 'DAYS',
    12: 'HOURS',
    13: 'MINUTES',
    14: 'SECONDS',
    15: 'MILLISECS'
};

export function format(value: number, unit: number) {
    value = numeral(value).format('0.[000]')
    return `${value} ${UNIT[unit]}`;
}


// WEBPACK FOOTER //
// ./src/components/widget/listMeasurements/UnitFormatter.ts